export const STATUS_ITEMS = [
  { value: 'open', text: 'Ouvert' },
  { value: 'in_progress', text: 'En cours' },
  { value: 'waiting_user', text: "En attente de l'utilisateur" },
  { value: 'resolved', text: 'Résolu' },
  { value: 'closed', text: 'Fermé' },
]

const COLORS = {
  open: 'info',
  in_progress: 'primary',
  waiting_user: 'warning',
  resolved: 'success',
  closed: 'grey',
}

export const statusLabel = (s) => (STATUS_ITEMS.find((i) => i.value === s) || {}).text || s
export const statusColor = (s) => COLORS[s] || 'grey'
export const formatDate = (iso) => (iso ? new Date(iso).toLocaleString('fr-FR') : '')
